import VirtualizedList from '../../vendor/react-native/VirtualizedList';
export default VirtualizedList;